import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const PreferencesSection = styled.div<{ $noBorder?: boolean }>`
  padding: ${space[4]} 0;
  border-top: ${({ $noBorder }) => ($noBorder ? 'none' : `1px solid ${semantic.border.default}`)};
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
  padding-bottom: ${space[3]};
`;

export const OtherInputWrapper = styled.div`
  padding: ${space[2]} 0;
`;

export const FreeTextWrapper = styled.div`
  padding-top: ${space[2]};
`;

export const LabelText = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  padding-bottom: ${space[3]};
`;
